import { Injectable } from "@angular/core";
import { ApiService, LocaleService } from "src/app/core/services";
import { ISettings } from "../types";

@Injectable({ providedIn: "root" })
export class SettingsService {
  private readonly endpoint = "/settings";
  private settingsID: number;
  settingsDetails: ISettings | null = null;

  constructor(private apiService: ApiService) {}

  async patch(
    partial: Partial<ISettings>
  ): Promise<{ data: ISettings | null; message: string }> {
    try {
      const payloadEntity = {
        properties: partial,
        id: this.settingsID || undefined,
      };
      await this.apiService.patch(payloadEntity, this.endpoint).toPromise();

      const res = await this.fetch();

      return {
        data: res,
        message: "NOTIFY.NT020",
      };
    } catch (err) {
      console.error("Failed to patch settings:", err);
    }
  }

  async save(
    settings: ISettings
  ): Promise<{ data: ISettings; message: string }> {
    const { ...payload } = settings;
    const payloadEntity = {
      properties: payload,
      id: this.settingsID || undefined,
    };
    let response, responseMsg, result, status;

    if (this.settingsID) {
      response = await this.apiService
        .patch(payloadEntity, this.endpoint)
        .toPromise();

      const settingsResult = await this.fetch();

      result = settingsResult;
      status = response.status;
      responseMsg = "NOTIFY.NT020";

      return { data: settingsResult, message: responseMsg };
    } else {
      response = await this.apiService
        .post(payloadEntity, this.endpoint)
        .toPromise();
      responseMsg = "NOTIFY.NT020";
      result = response.result;
      status = response.status;
    }

    if (status === 200 && result) {
      const props = result?.properties;
      if (props) {
        props["id"] = result.id;
      }
      this.settingsID = result.id;
      this.settingsDetails = props;

      return { data: this.settingsDetails, message: responseMsg };
    }
  }

  async fetch(): Promise<ISettings | null> {
    const response = await this.apiService.get(this.endpoint).toPromise();
    const { status, result } = response;

    if (status === 200 && result && result.length > 0) {
      const props = result[0].properties || result[0];
      this.settingsID = result[0].id;
      this.settingsDetails = props;
      return props as ISettings;
    }

    return null;
  }

  get menuAccess() {
    return this.settingsDetails?.menuAccess || [];
  }
}
